/* eslint-disable react/prop-types */
import MKTypography from "components/MKTypography";

function DownloadFiles({ property }) {
  return (
    <>
      <br />
      <MKTypography variant="h3" fontSize="17px" fontWeight="light" color="secondary">
        <span className="material-icons-outlined">cloud_download</span>&nbsp;Descarga de Archivos -
        Formatos
      </MKTypography>
      <table className="tableFiles">
        <tr>
          <td className="tdRows">
            <MKTypography variant="body1" fontSize="17px" fontWeight="light" color="inherit">
              <span className="material-icons-outlined">segment</span>
              JSON
            </MKTypography>
          </td>
          <td className="tdRows">
            <a href={property.json_files} target="_blank" download rel="noreferrer">
              <span className="material-icons-outlined">download</span>Descargar
            </a>
          </td>
        </tr>
        <tr>
          <td className="tdRows">
            <MKTypography variant="body1" fontSize="17px" fontWeight="light" color="inherit">
              <span className="material-icons-outlined">text_snippet</span>
              TXT
            </MKTypography>
          </td>
          <td className="tdRows">
            <a href={property.txt_files} target="_blank" download rel="noreferrer">
              <span className="material-icons-outlined">download</span>Descargar
            </a>
          </td>
        </tr>
        <tr>
          <td className="tdRows">
            <MKTypography variant="body1" fontSize="17px" fontWeight="light" color="inherit">
              <span className="material-icons-outlined">calendar_view_month</span>
              CSV
            </MKTypography>
          </td>
          <td className="tdRows">
            <a href={property.csv_files} target="_blank" rel="noreferrer">
              <span className="material-icons-outlined">download</span>Descargar
            </a>
          </td>
        </tr>
      </table>
    </>
  );
}

export default DownloadFiles;
